import { Button } from '@components/Button';
import getLayerStore from '@stores/LayerStore';

import type React from 'react';

interface GetInTouchBannerProps {
  buttonText: string;
}

const LayerStore = getLayerStore();

export const GetInTouchButton: React.FC<GetInTouchBannerProps> = ({ buttonText }) => {
  const handleClick = (): void => {
    LayerStore.setVisibilityWidgetX(true);
  };

  return (
    <Button onClick={handleClick} className={'CTA mt0'} primary large>
      {buttonText}
    </Button>
  );
};
